
const SwitchButton = ({open,handleSwitch}) => {

  return (
    <div 
      className={`switch-container ${open ? 'on' : ''}`}
      onClick={() => handleSwitch(!open)}
    >
      <div className="switch-handle" />
    </div>
  );
};

export default SwitchButton;